import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-dcca050a")

_pushScopeId("data-v-dcca050a")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "main__section" }
const _hoisted_3 = { class: "link-view" }
const _hoisted_4 = { class: "box" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "box-body" }, null, -1)
const _hoisted_6 = { class: "box-footer" }
const _hoisted_7 = {
  key: 0,
  class: "box-spinner"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_Alert = _resolveComponent("Alert")
  const _directive_scrollIcon = _resolveDirective("scrollIcon")

  return _withDirectives((_openBlock(), _createBlock("main", _hoisted_1, [
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Message, { severity: _ctx.messageSeverity }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.message), 1)
              ]),
              _: 1
            }, 8, ["severity"])
          ]),
          (_ctx.isFetching)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode(_component_ProgressSpinner)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            isConfirm: true,
            "onUpdate:clear": _cache[1] || (_cache[1] = 
          () => {
            _ctx.alert.content = '';
          }
        )
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_directive_scrollIcon]
  ])
})